/** Map plan names to number */
const planMapping = {
	free: 0,
	deluxe: 20,
} as const;

export default planMapping;


/** Determines whether a particular plan is a valid subscription plan */
export function isValidSubscriptionPlan(plan: number): plan is (typeof planMapping)[keyof typeof planMapping] {
	// @ts-expect-error
	return Object.values(planMapping).includes(plan);
}
